import { Component, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IMetaData } from "src/app/interfaces";

@Component({
    selector: "circ-metadata-date",
    templateUrl: "./date.component.html",
    styleUrls: ["./date.component.scss"],
    standalone: false
})
export class DateComponent {
  @Input()
  @Output()
  public data: IMetaData;

  @Input()
  public formGroup: FormGroup;
}
